import React from 'react';
import PropTypes from 'prop-types';
import {
    Tab,
    Nav,
    Card,
    Row,
    Container,
} from 'react-bootstrap';
import {
    AutoSizer,
} from 'react-virtualized';
import FloorScene from '@shared/components/FloorScene';

export default class FloorTabs extends React.Component {

    static propTypes = {
        tour: PropTypes.any,
        room: PropTypes.any,
        paneType: PropTypes.string,
        onRoomChange: PropTypes.func,
        onShowInfo: PropTypes.func,
    }

    state = {}

    componentDidUpdate(oldProps) {
        if (this.props.room && this.props.room !== oldProps.room) {
            this.setState({
                tabKey: 'floor-' + this.props.room.get('floor_id'),
            });
        }
    }

    render() {
        /* eslint-disable max-len */
        const {
            room,
            paneType,
            tour,
        } = this.props;
        const {
            tabKey,
        } = this.state;
        const floors = this.props.tour?.get('floors');
        if (!floors) {
            return null;
        }
        return (
            <Tab.Container
                id={"floor-tabs-" + paneType}
                className={`nav-toolbar h-100`}
                activeKey={tabKey}
                onSelect={tabKey => this.setState({tabKey})}
            >
                <Nav
                    justify
                    variant="tabs"
                    className="mt-2 floornav"
                >
                    {floors.map((floor) => {
                        if (paneType === 'floorplan' && !floor.get('floorplan')) {
                            return null;
                        }
                        return (
                            <Nav.Item key={floor.get('id')}>
                                <Nav.Link
                                    style={{
                                        backgroundColor: tabKey === 'floor-' + floor.get('id') ? tour.get('primaryColor') : 'white',
                                        color: tabKey === 'floor-' + floor.get('id') ? 'white' : tour.get('primaryColor'),
                                        borderBottom: tabKey === 'floor-' + floor.get('id') ? `1px solid ${tour.get('primaryColor')}` : '1px solid transparent',
                                    }}
                                    eventKey={"floor-" + floor.get('id')}
                                    as="a"
                                    href="#"
                                    disabled={false}
                                >
                                    {floor.get('name')}
                                </Nav.Link>
                            </Nav.Item>
                        );
                    })}
                </Nav>
                <Tab.Content
                    className="floortabs h-100"
                >
                    {floors.map((floor) => {
                        if (paneType === 'floorplan' && !floor.get('floorplan')) {
                            return null;
                        }
                        return (
                            <Tab.Pane
                                className="h-75 p-4"
                                eventKey={"floor-" + floor.get('id')}
                                key={floor.get('id')}
                            >
                                {paneType === 'rooms' &&
                                    <div>
                                        <Container fluid>
                                            <Row>
                                                {floor.get('rooms').map((currentRoom) => {
                                                    return (
                                                        <div
                                                            key = {currentRoom.get('id')}
                                                            className="mt-4 room-cards"
                                                        >
                                                            <Card
                                                                onClick={() => this.props.onRoomChange(currentRoom.get('id'))}
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <Card.Img
                                                                    variant="top"
                                                                    src={`/tour/${tour.get('id')}/panorama/${currentRoom.get('panorama')}/thumb`}
                                                                />
                                                                <Card.Body
                                                                    className="p-1"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        backgroundColor: currentRoom === room ? tour.get('primaryColor') : 'white',
                                                                    }}
                                                                >
                                                                    <p
                                                                        className="mb-0 text-center"
                                                                        style={{color: currentRoom === room ? 'white' : 'black'}}
                                                                    >
                                                                        {[currentRoom.get('name')]}
                                                                    </p>
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    );
                                                })}
                                            </Row>
                                        </Container>
                                    </div>
                                }
                                {paneType === 'floorplan' &&
                                    <AutoSizer>
                                        {({width, height}) => (
                                            <FloorScene
                                                entity={floor}
                                                width={width}
                                                height={height}
                                                readOnly={true}
                                                autoPlay={false}
                                                onSelectRoom={this.props.onRoomChange}
                                                onShowInfo={this.props.onShowInfo}
                                            />
                                        )}
                                    </AutoSizer>
                                }
                            </Tab.Pane>
                        );
                    })}
                </Tab.Content>
            </Tab.Container>
        );
    }
}
